import { useEffect, useState } from 'react'
import { Table, Space, Pagination, Input, Col, Row, Divider, Checkbox, Button } from 'antd'
import { isEmpty, size, trim } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import {
   CONFIG_URL,
   DATE_TIME_FORMAT_CLIENT_short2,
   PAGE_SIZE,
   ROLES,
   STATUS_ACTIVITY,
   getPage,
   getStatusText
} from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
// import Detail from './Detail'
import moment from 'moment'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { formatCurrency } from 'src/helpers/functions'
import useModal from 'src/helpers/modal/useModal'
import Create from './Create'
import Detail from './Detail'
import ExportToCSV from './ExportToCSV'
import ImagePreview, { getImageUrl } from 'src/common/components/ImagePreview'
import useTableScrollY from 'src/common/useTableScrollY'

const ProductsManagement = observer((props: any) => {
   const { t } = useTranslation()
   const ProductStore = useStore('ProductStore')
   const JobDetailStore = useStore('JobDetailStore')
   // const CommonConfigStore = useStore('CommonConfigStore')
   const AuthStore = useStore('AuthStore')
   const { data_getUserInfo } = AuthStore
   // const { designTypesList, productTypesList } = CommonConfigStore
   const [visible, setVisible] = useState(false)
   const [textSearch, set_textSearch] = useState('')
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   // const [isLoading, setIsLoading] = useState(false)
   const [visibleCreate, setVisibleCreate] = useState(false)
   const [visibleDetail, setVisibleDetail] = useState(false)
   const [visibleFilter, setVisibleFilter] = useState(false)
   const [item, setItem] = useState(null)
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   // const [status, setStatus] = useState(POSITION_INFO.ALL.id)
   // const history = useHistory()
   const [fieldFilter, setFieldFilter] = useState<any>({})
   const [statusObj, setStatusObj] = useState<any>({
      new: [STATUS_ACTIVITY.NEW],
      doing: [STATUS_ACTIVITY.DOING],
      review: '',
      finish: '',
      reject: [STATUS_ACTIVITY.REJECT]
   })
   const { jobTotal } = ProductStore
   const { rows, offset, count } = ProductStore.products
   const { paginationRef, scrollY, tableWrapperRef } = useTableScrollY({
      dependencyKey: `${rows?.length || 0}-${count}`
   })
   const [isOpenEditJobDetail, setIsOpenEditJobDetail] = useState(false)
   const [selectedItem, setSelectedItem] = useState<any>([])

   const [visibleAssign, setVisibleAssign] = useState<any>(false)
   const [itemUser, setItemUser] = useState<any>(null)
   const [itemDesigner, setItemDesigner] = useState(null)
   const [itemCreator, setItemCreator] = useState(null)
   const [visibleUserDetailCreator, setVisibleUserDetailCreator] = useState<any>(false)
   const [visibleUserDetailDesigner, setVisibleUserDetailDesigner] = useState<any>(false)
   const { confirm } = useModal()

   useEffect(() => {
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()

      getListData(0, {
         ...fieldFilter,
         ...{ name: trim(textSearch) }
         // ...{ status: statusResult }
      })
      // JobsStore.getJobTotal(statusResult)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch])

   const onSubmitFilter = (value: any) => {
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()
      // console.log('statusNow: ', statusObj, 'statusResult; ', statusResult)
      // setFieldFilter({ ...fieldFilter, ...{ status: statusResult } })
      setFieldFilter({
         ...fieldFilter,
         ...value
         // ...{ status: statusResult }
      })
      getListData(0, {
         ...fieldFilter,
         ...{ name: trim(textSearch) },
         ...value
         //  ...{ status: statusResult }
      })
   }

   const onResetFilter = () => {
      const page = 0
      setFieldFilter({})
      getListData(0, { ...{ name: trim(textSearch) } })
   }

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage, PAGE_SIZE)
         const params = { offset, ...param }

         await ProductStore.getProducts(params)
      } catch (error) {
         // console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      // console.log('currentPage;', currentPage, 'currentPage-1', currentPage - 1)
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()

      getListData(currentPage - 1, {
         ...fieldFilter,
         ...{ name: trim(textSearch) } // ...{ status: statusResult }
      })
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }

   const handleShowDetail = (item: any) => {
      setItem(item)
      // JobDetailStore.setJobDetail(item)
      setVisibleDetail(true)
   }

   const handleAssignJob = (item: any) => {
      setSelectedItem(item)
      JobDetailStore.setJobDetail(item)
      setVisibleAssign(true)
   }

   const handleCloseAssign = () => {
      setVisibleAssign(false)
   }
   const openEditJobModal = () => {
      setIsOpenEditJobDetail(true)
   }

   const closeEditJobModal = () => {
      setIsOpenEditJobDetail(false)
   }

   const onChangeStatus = (key: string | number, e: any) => {
      // let notOrder = OrderStore.optionSearchOrderCustomer.status.includes(1) ? [1] : []
      // let placingData = OrderStore.optionSearchOrderCustomer.status.includes(2) ? [2] : []
      // let orderFinish = OrderStore.optionSearchOrderCustomer.status.includes(3) ? [3] : []
      // let soldOut = OrderStore.optionSearchOrderCustomer.status.includes(4) ? [4] : []
      let statusNow = { ...statusObj }
      switch (key) {
         case STATUS_ACTIVITY.NEW:
            if (e.target.checked) {
               statusNow.new = [STATUS_ACTIVITY.NEW]
            } else {
               statusNow.new = []
            }
            break
         case STATUS_ACTIVITY.DOING:
            if (e.target.checked) {
               statusNow.doing = [STATUS_ACTIVITY.DOING]
            } else {
               statusNow.doing = []
            }
            break
         case STATUS_ACTIVITY.REVIEW:
            if (e.target.checked) {
               statusNow.review = [STATUS_ACTIVITY.REVIEW]
            } else {
               statusNow.review = []
            }
            break
         case STATUS_ACTIVITY.REJECT:
            if (e.target.checked) {
               statusNow.reject = [STATUS_ACTIVITY.REJECT]
            } else {
               statusNow.reject = []
            }
            break
         default:
            if (e.target.checked) {
               statusNow.finish = [STATUS_ACTIVITY.FINISH]
            } else {
               statusNow.finish = []
            }
            break
      }
      setStatusObj(statusNow)
      // let dataStatus = [...placingData, ...notOrder, ...orderFinish, ...soldOut]
      // OrderStore.setOptionSearchOrderCustomer({ status: dataStatus })

      const statusResult = [
         ...statusNow.new,
         ...statusNow.doing,
         ...statusNow.review,
         ...statusNow.reject,
         ...statusNow.finish
      ].toString()
      // console.log('statusNow: ', statusNow, 'statusResult; ', statusResult)
      setFieldFilter({
         ...fieldFilter
         // ...{ status: statusResult }
      })
      getListData(0, {
         ...fieldFilter,
         ...{ name: trim(textSearch) } //...{ status: statusResult }
      })
   }

   const handleDeleteProduct = (value: any) => {
      confirm({
         title: t(GLOBAL_CLIENT.banmuonxoabanghi),
         icon: <ExclamationCircleOutlined />,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await ProductStore.deleteProduct(value?.id)
            if (size(trim(textSearch)) > 0) {
               getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
            } else {
               getListData(0, { ...fieldFilter })
            }
         }
      })
   }
   const handlePriority = async (value: any, status: boolean, index: number) => {
      try {
         const res = await JobDetailStore.setJobPriority(value?.id, status)
         console.log('res', res)
         if (res) {
            // Sửa dữ liệu offline
            ProductStore.action_updateJobPriority(index, status)
         }
      } catch (error) {
         console.log(error)
      } finally {
      }

      // confirm({
      //    title: t(GLOBAL_CLIENT.setuutien),
      //    icon: <ExclamationCircleOutlined />,
      //    okText: t(GLOBAL_CLIENT.dongy),
      //    cancelText: t(GLOBAL_CLIENT.huy),
      //    onCancel() {},
      //    async onOk() {
      //       await JobDetailStore.setJobPriority(value?.id)
      //       if (size(trim(textSearch)) > 0) {
      //          getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      //       } else {
      //          getListData(0, { ...fieldFilter })
      //       }
      //    }
      // })
   }
   const handleEditDesigner = () => {
      // handle_getListData(page)
      hideDetailDesigner()
   }
   const handleEditCreator = () => {
      // handle_getListData(page)
      hideDetailCreator()
   }
   const handleCreate = () => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      setVisibleCreate(false)
      setItem(null)
   }
   const handleEdit = () => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      setVisibleDetail(false)
      setItem(null)
   }

   const hideDetailDesigner = () => {
      setVisibleUserDetailDesigner(false)
      setItemDesigner(null)
   }
   const hideDetailCreator = () => {
      setVisibleUserDetailCreator(false)
      setItemCreator(null)
   }

   const showDetailCreator = (item: any) => () => {
      setItemCreator(item)
      setTimeout(() => {
         setVisibleUserDetailCreator(true)
      }, 300)
   }
   const showDetailDesigner = (item: any) => () => {
      setItemDesigner(item)
      setTimeout(() => {
         setVisibleUserDetailDesigner(true)
      }, 300)
   }

   const handleCancelJob = (value: any) => {
      confirm({
         title: t(GLOBAL_CLIENT.banmuonhuyjob),
         icon: <ExclamationCircleOutlined />,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await ProductStore.cancelProduct(value?.id)
            if (size(trim(textSearch)) > 0) {
               getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
            } else {
               getListData(0, { ...fieldFilter })
            }
         }
      })
   }

   let columns = [
      // {
      //     title: t(GLOBAL_CLIENT.sothutu),
      //     dataIndex: "index",
      //     key: "index",
      //     align: "center" as "center",
      //     width: 80,
      //     // fixed: 'left',
      //     render: (value: string, record: any, index: number) =>
      //         (page-1) * PAGE_SIZE + index + 1,
      // },
      {
         title: 'ID',
         dataIndex: 'id',
         key: 'id',
         width: 50,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
         // fixed: 'left',
      },
      {
         title: 'Tên',
         dataIndex: 'name',
         key: 'name',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
         // fixed: 'left',
      },
      {
         title: t(GLOBAL_CLIENT.txtDateTime),
         dataIndex: 'createdAt',
         key: 'createdAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: 'Cập nhật cuối',
         dataIndex: 'updatedAt',
         key: 'updatedAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.image),
         dataIndex: 'images',
         width: 80,
         key: 'images',
         render: (value: any) => {
            return value && value[0] ? (
               <ImagePreview src={getImageUrl(value[0], CONFIG_URL.IMAGE_URL)} size={64} fit="contain" />
            ) : (
               <></>
            )
         }
      },
      {
         title: 'Giá bán',
         dataIndex: 'priceDefault',
         width: 80,
         key: 'baseCost',
         render: (value: any) => {
            return <span className="txtMax2Line">${formatCurrency(value?.baseCost)}</span>
         }
      },
      {
         title: 'Giá ship',
         dataIndex: 'priceDefault',
         width: 80,
         key: 'shippingFee',
         render: (value: any) => {
            return <span className="txtMax2Line">${formatCurrency(value?.shippingFee)}</span>
         }
      },
      {
         title: 'Trạng thái',
         dataIndex: 'status',
         width: 80,
         key: 'status',
         render: (value: boolean) => {
            return (
               <Checkbox disabled defaultChecked={value}>
                  {t(value ? GLOBAL_CLIENT.active : GLOBAL_CLIENT.inactive)}
               </Checkbox>
            )
         }
      },
      // {
      //    title: 'Is Partner?',
      //    key: 'isPartner',
      //    dataIndex: 'isPartner',
      //    width: 80,
      //    align: 'center' as 'center',
      //    // fixed: 'right' as 'right',
      //    render: (value: any, record: any) => {
      //       return <span className="txtMax2Line">{value ? 'Partner' : ''}</span>
      //    }
      // },
      {
         title: 'Dành cho',
         key: 'isPrivate',
         dataIndex: 'isPrivate',
         width: 80,
         align: 'center' as 'center',
         // fixed: 'right' as 'right',
         render: (value: any, record: any) => {
            return <span className="txtMax2Line">{value ? 'Giới hạn' : 'Tất cả'}</span>
         }
      }
   ]
   if (data_getUserInfo?.role === ROLES.FULFILLMENT) {
      columns = columns.filter((c) => !['priceDefault', 'status', 'isPrivate'].includes(c.dataIndex))
   }
   const col2 =
      data_getUserInfo?.role == ROLES.FULFILLMENT
         ? [
              {
                 title: 'Giá ship',
                 dataIndex: 'shipping_fee',
                 width: 80,
                 key: 'shipping_fee',
                 render: (value: any) => {
                    return <span className="txtMax2Line">${formatCurrency(value)}</span>
                 }
              },
              {
                 title: 'Phí đóng hàng',
                 dataIndex: 'packing_fee',
                 width: 80,
                 key: 'packing_fee',
                 render: (value: any) => {
                    return <span className="txtMax2Line">${formatCurrency(value)}</span>
                 }
              },
              {
                 title: 'Phí quản lý đơn',
                 dataIndex: 'handing_fee',
                 width: 80,
                 key: 'handing_fee',
                 render: (value: any) => {
                    return <span className="txtMax2Line">${formatCurrency(value)}</span>
                 }
              }
           ]
         : []
   const col3 = [
      {
         title: 'Action',
         key: 'action',
         width: 110,
         align: 'center' as 'center',
         fixed: 'right' as 'right',
         render: (text: string, record: any, index: number) => {
            return (
               <span className="txtMax2Line">
                  {/* {record?.status === STATUS_ACTIVITY.NEW && <AssignJob detail={record} indexItem={index} />} */}
                  <span onClick={() => handleShowDetail(record)} className="gx-link txtMax2LineHover">
                     {t(GLOBAL_CLIENT.detail)}
                  </span>
                  {data_getUserInfo?.role !== ROLES.FULFILLMENT && (
                     <>
                        <Divider type="vertical" />
                        <span onClick={() => handleDeleteProduct(record)} className="gx-link txtMax2LineHover">
                           {t(GLOBAL_CLIENT.delete)}
                        </span>
                     </>
                  )}
               </span>
            )
         }
      }
   ]
   const hideCreate = () => {
      setVisibleCreate(false)
      setItem(null)
   }
   const hideDetail = () => {
      setVisibleDetail(false)
      setItem(null)
   }
   const showCreate = () => {
      setVisibleCreate(true)
   }

   const onChangePriority = (item: any, e: any, index: number) => {
      console.log('item: ', item, 'e', e, 'inde', index)
      // setRememberMe(e.target.checked)
      handlePriority(item, e.target.checked, index)
   }

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination" ref={paginationRef}>
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   return (
      <>
         {/* <Loading isLoading={isLoading} /> */}
         <Row>
            <Col span={24}>
               <Row className="row-container-head">
                  <Col xs={24} md={8}>
                     <Input.Search
                        onSearch={handleChangeTextSearch}
                        placeholder={t(GLOBAL_CLIENT.search)}
                        allowClear
                        enterButton
                     />
                  </Col>
                  <Col xs={24} md={2}>
                     {/* <Button type="primary" className="btn-add" onClick={handleFilter}>
                        <i className="icon icon-filter icon-in-button" />
                        {t(GLOBAL_CLIENT.filter)}
                     </Button> */}
                     {/* <Filter onSubmitFilter={onSubmitFilter} onResetFilter={onResetFilter} /> */}
                  </Col>
                  {/* <Col xs={24} md={12}>
                     <Input.Search onSearch={handleChangeTextSearch} placeholder={t(GLOBAL_CLIENT.search)} allowClear />
                  </Col> */}
                  <Col xs={24} md={14}>
                     <div className="text-right">
                        <Space>
                           <ExportToCSV />
                           <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />

                              {t(GLOBAL_CLIENT.create)}
                           </Button>
                           {/* <Button className="btn-add">
                              <span style={{ fontWeight: 'bold', paddingRight: 8 }}>Tổng tiền</span>
                              <span style={{ fontSize: 20, color: '#89AD88', fontWeight: 'bolder' }}>{`${formatCurrency(
                                 DebtsStore.totalDebtsCreator,
                                 true
                              )} VND`}</span>
                           </Button> */}
                        </Space>
                     </div>
                     {/* <div className="text-right">
                        <Space>
                           <Button className="btn-add">
                              <span style={{ fontWeight: 'bold', paddingRight: 8 }}>Tổng SL mẫu</span>
                              <span
                                 style={{ fontSize: 20, color: theme.color.primary, fontWeight: 'bolder' }}
                              >{`${formatCurrency(jobTotal?.count, true)}`}</span>
                           </Button>
                           <Button className="btn-add">
                              <span style={{ fontWeight: 'bold', paddingRight: 8 }}>Tổng tiền</span>
                              <span style={{ fontSize: 20, color: '#89AD88', fontWeight: 'bolder' }}>{`${formatCurrency(
                                 jobTotal?.price,
                                 true
                              )} VND`}</span>
                           </Button>
                        </Space>
                     </div> */}
                  </Col>
               </Row>
               <Space
                  className="total-items"
                  style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}
               >
                  <div>
                     {t(GLOBAL_CLIENT.totalItems)}: {count}
                  </div>
                  {/* <div>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.NEW, e)}
                     >
                        {'Mới'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.DOING, e)}
                     >
                        {'Đang xử lí'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={false}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.REVIEW, e)}
                     >
                        {'Review'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.REJECT, e)}
                     >
                        {t(GLOBAL_CLIENT.cansualai)}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={false}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.FINISH, e)}
                     >
                        {'Hoàn thành'}
                     </Checkbox>
                  </div> */}
               </Space>
               {/* <Space className="total-items">
                  {t(GLOBAL_CLIENT.totalItems)}: {count}
               </Space> */}

               <div ref={tableWrapperRef}>
                  <Table
                     scroll={{ x: 1500, y: scrollY }}
                     columns={[...columns, ...col2, ...col3]}
                     dataSource={rows}
                     rowKey="id"
                     pagination={false}
                  />
               </div>

               {renderPagination()}
            </Col>
         </Row>

         {/* {item && <Detail visible={visibleDetail} item={item} onOk={handleEdit} onCancel={hideDetail} />} */}
         {/* <Filter visible={visibleFilter} onOk={confirmFilter} onCancel={hideFilter} /> */}
         {visibleCreate && <Create visible={visibleCreate} item={item} onOk={handleCreate} onCancel={hideCreate} />}
         {visibleDetail && item && (
            <Detail visible={visibleDetail} item={item} onOk={handleEdit} onCancel={hideDetail} />
         )}
      </>
   )
})

export default ProductsManagement
